import React from "react";
import { CheckCircle2 } from "lucide-react";

/**
 * Stepper horizontal compacto para wizards multi-etapa.
 * Cada step tem { key, label, done?, current? }.
 * O current é destacado em azul; done em verde com ícone de check.
 */
export function ActivationStepper({ steps, testId = "activation-stepper" }) {
  return (
    <div
      data-testid={testId}
      className="flex items-center gap-1 sm:gap-2 my-4 overflow-x-auto pb-1"
    >
      {steps.map((s, idx) => {
        const isLast = idx === steps.length - 1;
        return (
          <React.Fragment key={s.key}>
            <div className="flex items-center gap-2 shrink-0">
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-bold transition-all ${
                  s.done
                    ? "bg-emerald-500 text-white"
                    : s.current
                      ? "bg-blue-600 text-white ring-4 ring-blue-100"
                      : "bg-slate-100 text-slate-400"
                }`}
              >
                {s.done ? <CheckCircle2 size={14} /> : idx + 1}
              </div>
              <span
                className={`text-xs font-medium whitespace-nowrap hidden sm:inline ${
                  s.done
                    ? "text-emerald-700"
                    : s.current
                      ? "text-blue-700"
                      : "text-slate-400"
                }`}
              >
                {s.label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`h-0.5 flex-1 min-w-[16px] rounded-full transition-colors ${
                  s.done ? "bg-emerald-500" : "bg-slate-200"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
